import React from 'react';
import { Result, VertButton } from '@vertem-core/vertice-ds';
import { useNavigate } from 'react-router-dom';

const UnauthorizedSpot = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="Solicitação"
      subTitle=" Não foi possível acessar a página solicitada, por favor, verifique suas credenciais de acesso."
      extra={
        <VertButton
          type="default"
          onClick={() => navigate('/list-redemptions')}
        >
          Ver Solicitações
        </VertButton>
      }
      style={{
        fontSize: '20px',
      }}
    />
  );
};

export default UnauthorizedSpot;
